const InputText = ({ value, placeholder, setValue, type = "text", className }) => (
    <input type={type} className={"owl-input " + className} value={value} placeholder={placeholder} onChange={({ target }) => setValue(target.value)} />
);
export default InputText;
